
// Function to communicate with Swift app for SKOverlay
export const showSKOverlay = (appStoreId: string, onDismissCallback?: () => void): void => {
  console.log(`Requesting SKOverlay for App Store ID: ${appStoreId}`);
  console.log('Current onSKOverlayDismissed handler:', typeof (window as any).onSKOverlayDismissed);
  
  // Register global dismiss handler
  (window as any).onSKOverlayDismissed = () => {
    console.log('SKOverlay dismiss callback triggered from native');
    console.log('Has onDismissCallback:', !!onDismissCallback);
    if (onDismissCallback) {
      console.log('Executing onDismissCallback');
      onDismissCallback();
    }
  };
  
  console.log('Registered new onSKOverlayDismissed handler');
  
  // Check if we're in a WebView with the native function available
  if (window.webkit?.messageHandlers?.showSKOverlay) {
    console.log('Calling showSKOverlay with appStoreId:', appStoreId);
    window.webkit.messageHandlers.showSKOverlay.postMessage(appStoreId);
    console.log('showSKOverlay completed successfully');
  } else {
    // Fallback for development/web testing
    console.log('SKOverlay would be shown for App Store ID:', { appStoreId });
  }
};

// Function to close SKOverlay
export const closeSKOverlay = (): void => {
  console.log('Requesting to close SKOverlay');
  
  // Check if we're in a WebView with the native function available
  if (window.webkit?.messageHandlers?.showSKOverlay) {
    window.webkit.messageHandlers.showSKOverlay.postMessage(null);
  } else {
    // Fallback for development/web testing
    console.log('SKOverlay would be closed');
  }
};

// Extend Window interface for TypeScript
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        showSKOverlay?: {
          postMessage: (message: any) => void;
        };
        /*closeSKOverlay?: {
          postMessage: (message: any) => void;
        };*/
      };
    };
  }
}
